import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import { getMessage } from "@/utils/MessageUtils"

class ContactStatus extends React.Component {
  static propTypes = {
    status: PropTypes.string,
  }

  render() {
    const { status } = this.props
    if (!status) {
      return null
    }
    return <span>{getMessage(status, "ContactStatus")}</span>
  }
}

export default ContactStatus
